import React from "react";
import PublicV2Layout from "../layout/PublicV2Layout";
import CustomerInvoicePage from "../../pages/CustomerInvoicePage/CustomerInvoicePage";
import "./customerDocV2.css";

const noop = () => {};

/**
 * v2 chrome around the existing customer Invoice display (reused as-is). See
 * CustomerQuotePageV2 for the wrapper rationale.
 */
const CustomerInvoicePageV2 = (navProps) => (
  <PublicV2Layout {...navProps}>
    <div className="bdrv2-doc bdrv2-section">
      <div className="bdrv2-container bdrv2-customer-doc">
        <CustomerInvoicePage
          displayNav={noop}
          changeStickyTab={noop}
          changeFooter={noop}
        />
      </div>
    </div>
  </PublicV2Layout>
);

export default CustomerInvoicePageV2;
